export const config = {
  formId: 'subscription_notifications',
  formTitle: 'Subscription Notifications',
  formValueType: 'Object',
  tabs: [
    {
      id: 'subscription_notifications',
      contents: [
        {
          id: 'email',
          style: 'subnotificationform',
          fields: [
            {
              formtitle: 'Email Notification',
              type: 'FortellisTitle3',
              style: 'subnotificationtitle'
            },
            {
              formtitle:
                'We will send new subscription emails to the address(es) listed below.',
              type: 'FormCaption',
              gridStyle: 'layoutcell',
              style: 'subnotificationcaption'
            },
            {
              formtitle: 'You can add upto 5 email addresses.',
              type: 'FormCaption',
              gridStyle: 'layoutcell',
              style: 'subnotificationcaption'
            },
            {
              name: 'email',
              label: 'Type email address and press enter',
              type: 'input_chipset',
              containerStyle: 'sub-notification-input-chipset',
              required: true
            }
          ]
        },
        {
          id: 'api',
          fields: [
            {
              formtitle: 'API Notification',
              type: 'FortellisTitle3',
              style: 'subnotificationtitle'
            },
            {
              formtitle:
                'By checking this item, we will notify the URL below about new subscriptions.',
              type: 'FormCaption',
              gridStyle: 'layoutcell',
              style: 'subnotificationcaption'
            },
            {
              id: 'apiNotification',
              name: 'apiNotification',
              labelDependsOn: 'apiNotification',
              label: function(apiNotification) {
                if (apiNotification) return 'API Notification Enabled';
                else return 'API Notification Disabled';
              },
              type: 'on_off_switch',
              style: 'formtextfield',
              gridStyle: 'layoutcell',
              toolTipText:
                'Enable the API notification to call the API to receive subscription notifications'
            },
            {
              id: 'endpointUrl',
              label: 'Endpoint URL',
              name: 'endpointUrl',
              type: 'text_field',
              style: 'formtextfield',
              gridStyle: 'layoutcell',
              dependentOn: 'apiNotification',
              show: function(dependOn) {
                return dependOn;
              }
            },
            {
              type: 'api_request',
              gridStyle: 'layoutCellList',
              dependentOn: 'apiNotification',
              show: function(dependOn) {
                return dependOn;
              }
            }
          ]
        }
      ]
    }
  ],

  formFields: {
    subscription_notifications: {
      email: '',
      apiNotification: false,
      endpointUrl: '',
      apiRequestBody: '',
      apiResponse: ''
    }
  },
  requiredFields: ['email'],
  activeTabId: 'subscription_notifications'
};
